// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceReportPage-cls1_crP","cls2":"ReferenceReportPage-cls2_ScV ReferenceReportPage-cls1_crP"};